import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { fetchStockPublicationSettings } from "../../api/thunks/fetchStockPublicationSettings";
import { cloneSettings } from "../../lib/cloneSettings";
import { StockPublicationSliceState } from "../../types";

export const addFetchSettingsExtraReducers = (
  builder: ActionReducerMapBuilder<StockPublicationSliceState>,
) => {
  builder
    .addCase(fetchStockPublicationSettings.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    })
    .addCase(fetchStockPublicationSettings.fulfilled, (state, action) => {
      state.isLoading = false;
      state.dictionaries = action.payload.dictionaries;
      state.savedSettings = action.payload.settings;
      state.draftSettings = cloneSettings(action.payload.settings);
    })
    .addCase(fetchStockPublicationSettings.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload ?? "Ошибка загрузки";
    });
};
